// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2_e3n","itemTitle":"ClientEmergencyInfo_itemTitle__1psq2","itemText":"ClientEmergencyInfo_itemText__3AEbC"};